import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import './PracticePerfectProgress.css';
import Spinner from '../../Spinner/Spinner';
import { PieChart } from 'react-minimal-pie-chart';
import loadingIcon from '../../Spinner/loadingIcon.gif';
import { handleException } from '../../../app/util/util';
import loaderColors1 from '../../Spinner/loaderColors1.gif';
export default function PPConfidenceDashboard(props) {
    var ppProgrPageInfo = props.ppProgrPageInfo;
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [isPpConfLevelLoad, setIsPpConfLevelLoad] = useState(true);
    const [ppConfidenceOverall, setPpConfidenceOverall] = useState([]);
    const [isPpConfDashLoading, setIsPpConfDashLoading] = useState(true);
    const [ppConfidenceLevel, setPpConfidenceLevel] = useState(Number("0").toFixed(2));
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    const fetchConfidenceLevel = async () => {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "themisSubjectAreaId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppProgrPageInfo.SATagId
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppProgrPageInfo.SATagId,
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getConfidenceLevel`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.ppConfidenceLevel) {
                        setPpConfidenceLevel(Number(data.ppConfidenceLevel).toFixed(2));
                    }
                    setIsPpConfLevelLoad(false);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const fetchOverallProgress = async () => {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "themisSubjectAreaId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppProgrPageInfo.SATagId,
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppProgrPageInfo.SATagId,
            "ppProductVO": { "productId": ppProgrPageInfo.ProductID }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getTopicsForConfidencePage`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.ppTopicVOList) {
                        var ppTopicList = Array.isArray(data.ppTopicVOList) ? data.ppTopicVOList : [data.ppTopicVOList];
                        ppTopicList = ppTopicList.map(ppTopic => {
                            if (ppTopic.ppSubTopicVOList) {
                                ppTopic.ppSubTopicVOList = Array.isArray(ppTopic.ppSubTopicVOList) ? ppTopic.ppSubTopicVOList : [ppTopic.ppSubTopicVOList];
                            }
                            return { ...ppTopic, topic_expand_status: false }
                        });
                        setPpConfidenceOverall(ppTopicList);
                    }
                    setIsPpConfDashLoading(false);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        fetchConfidenceLevel();
        fetchOverallProgress();
    }, []);
    function handlePPConfLevelPieChart() {
        var pieChartData = [
            { title: '', value: ppConfidenceLevel, color: '#007AC3' },
            { title: '', value: (100 - ppConfidenceLevel), color: '#fff' }
        ]
        return pieChartData;
    }
    function handlePPConfTopicExpCollpAll(topicExpandSt) {
        const newTopicExpandState = ppConfidenceOverall.map(ppTopic => {
            return { ...ppTopic, topic_expand_status: topicExpandSt }
        });
        setPpConfidenceOverall(newTopicExpandState)
    }
    function handlePPConfTopicExpCollp(topicOrderIndex, topicExpandSt) {
        const newTopicExpandState = ppConfidenceOverall.map(ppTopic => {
            if (ppTopic.orderIndex === topicOrderIndex) {
                return { ...ppTopic, topic_expand_status: topicExpandSt }
            }
            return ppTopic;
        });
        setPpConfidenceOverall(newTopicExpandState)
    }
    function getDiffCurrToQuizDate(dateToCompare) {
        var estTime = moment.tz(dateToCompare, "America/New_York");
        var convTime = estTime.clone().tz(moment.tz.guess());
        var currTime = moment.tz(moment.tz.guess());
        var difference = moment.utc(moment(convTime)).diff(moment(currTime), "days");
        const result = Math.abs(difference) >= 14 ? true : false
        return result
    }
    return (
        <>
            <Spinner
                loading={isPpConfDashLoading}
                imageSrc={loadingIcon}
                imageStyle={{ marginTop: "20%", width: "50px" }}
                overlayBackground="rgba(0,0,0,0)"
            />
            {
                isPpConfDashLoading === false &&
                <>
                    <div className='row'>
                        <div className='col-xl-9 col-lg-9 col-md-7 col-sm-12 col-12'>
                            <p className='ppConfDashTitle'>How well do you know {ppProgrPageInfo.ProductName}?</p>
                            <p className='ppConfDashTitleTxt'>
                                Your confidence level is a combination of the questions you’ve
                                answered and how recently you’ve taken them. Looking for more
                                questions in a topic? Browse the specialized quizzes in the Quiz Center.
                            </p>
                        </div>
                        <div className='col-xl-3 col-lg-3 col-md-5 col-sm-12 col-12'>
                            <p className='ppConfDashTitle'>Your Confidence Level: </p>
                            <div className="ppConfDashPathChartText no-padding">
                                {
                                    isPpConfLevelLoad === true ?
                                        <PieChart totalValue={100} startAngle={180} lengthAngle={180} lineWidth={45} background={'#f0f0f0'} viewBoxSize={[100, 54]} /> :
                                        <PieChart totalValue={100} startAngle={180} lengthAngle={180} lineWidth={45} background={'#000'} viewBoxSize={[100, 54]}
                                            data={handlePPConfLevelPieChart()}
                                            label={({ dataEntry, dataIndex }) => {
                                                return (
                                                    isPpConfLevelLoad === false && dataIndex === 0 &&
                                                    <text x={
                                                        dataEntry.value < 10 ? 33 :
                                                            dataEntry.value < 100 ? 30 : 25
                                                    } y={50}>
                                                        {dataEntry.value + "%"}
                                                    </text>
                                                )
                                            }}
                                        />
                                }
                                <Spinner
                                    loading={isPpConfLevelLoad}
                                    imageSrc={loaderColors1}
                                    imageStyle={{ marginTop: "-26%", width: "100px", marginRight: "30px" }}
                                    overlayBackground="rgba(0,0,0,0)"
                                />
                            </div>
                        </div>
                    </div>
                    <hr className='w-100 ppConfBorderMargins'></hr>
                    <div className="ppConfPreviews ppConfLevelMargins mb-3 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right no-padding">
                        <a onClick={() => handlePPConfTopicExpCollpAll(true)}>
                            <span className="ppConfPreviewExpandAll">Expand All</span>
                        </a>
                        <span className="ppConfPreviewPipeLine"> | </span>
                        <a onClick={() => handlePPConfTopicExpCollpAll(false)}>
                            <span className="ppConfPreviewCollapseAll">Collapse All</span>
                        </a>
                    </div>
                    <div className="ppConfOverallProgMargins col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                        {
                            ppConfidenceOverall.map((ppTopic, index) => {
                                const fadedParent = ppTopic.ppSubTopicVOList && ppTopic.ppSubTopicVOList.filter((topic) => getDiffCurrToQuizDate(topic.attemptedDateInDateFormat))
                                return (
                                    <>
                                        {ppTopic.totalQuestions ?
                                            <>
                                                <div className='mb-1' style={{ display: "flex" }} key={index}>
                                                    <div className='ppConfTopicNames col-xl-9 col-lg-9 col-md-8 col-sm-8 col-8 no-padding'>
                                                        {ppTopic.customerFacingTopicName}
                                                    </div>
                                                    <div className="ppConfExpCollBtnStyle col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4 no-padding">
                                                        {
                                                            ppTopic.ppSubTopicVOList ?
                                                                <button className="ppConfExpCollBtn" onClick={() =>
                                                                    handlePPConfTopicExpCollp(ppTopic.orderIndex, ppTopic.topic_expand_status ? false : true)}>
                                                                    {ppTopic.topic_expand_status === true ? 'Collapse' : 'Expand'}
                                                                </button> : null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="progress ppConfTopicProgress mb-2">
                                                    {
                                                        ppTopic.score === undefined ?
                                                            <div className="progress-bar ppConfTopicProgressBarNo">No Score</div> :
                                                            Number(ppTopic.score) > 0 ?
                                                                <>
                                                                    <div className={"progress-bar " + (fadedParent.length ? `ppConfTopicProgressBarGra` : `ppConfTopicProgressBar`)} style={{ width: (Number(ppTopic.score) + '%') }}>
                                                                        {Number(ppTopic.score) > 16 ? (Number(ppTopic.score).toFixed(2) + '%') : null}
                                                                    </div>
                                                                    {Number(ppTopic.score) > 16 ? null : <div className="progress-bar ppConfTopicProgressBarLess16">{Number(ppTopic.score).toFixed(2) + '%'}</div>}
                                                                </> :
                                                                <div className="progress-bar ppConfTopicProgressBarZero">{ppTopic.score + '%'}</div>
                                                    }
                                                </div>
                                                {
                                                    ppTopic.topic_expand_status === true ?
                                                        ppTopic.ppSubTopicVOList && ppTopic.ppSubTopicVOList.map(ppSubTopic => {
                                                            return (
                                                                <>
                                                                    <div style={{ marginLeft: '10%' }}>
                                                                        <div className='ppConfSubTopicNames mt-1 mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding'>
                                                                            {ppSubTopic.customerFacingSubTopicName}
                                                                        </div>
                                                                        <div className="ppConfSubTopicQuesTxt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                                                            <span>Total Questions: {ppSubTopic.totalQuestions} | </span>
                                                                            <span>Questions Attempted: {ppSubTopic.attemptedCount === undefined ? `0` : ppSubTopic.attemptedCount} | </span>
                                                                            <span>Questions Correct: {ppSubTopic.correctCount === undefined ? `0` : ppSubTopic.correctCount}</span>
                                                                        </div>
                                                                        {
                                                                            ppSubTopic.attemptedDateInDateFormat && getDiffCurrToQuizDate(ppSubTopic.attemptedDateInDateFormat) && (
                                                                                <span className="ppConfSubTopicQuesTxt">
                                                                                    Your progress is fading because you haven’t reviewed this topic in over two weeks. Take a quiz to update your score.
                                                                                </span>
                                                                            )
                                                                        }
                                                                        <div className="progress ppConfSubTopicProgress mt-1 mb-3">
                                                                            {
                                                                                ppSubTopic.score === undefined ?
                                                                                    <div className="progress-bar ppConfSubTopicProgressBarNo">No Score</div> :
                                                                                    Number(ppSubTopic.score) > 0 ?
                                                                                        <>
                                                                                            <div className={"progress-bar " + (getDiffCurrToQuizDate(ppSubTopic.attemptedDateInDateFormat) ? "ppConfSubTopicProgressBarGra" : "ppConfSubTopicProgressBar")} style={{ width: (Number(ppSubTopic.score) + '%') }}>
                                                                                                {Number(ppSubTopic.score) > 16 ? (Number(ppSubTopic.score).toFixed(2) + '%') : null}
                                                                                            </div>
                                                                                            {Number(ppSubTopic.score) > 16 ? null : <div className="progress-bar ppConfSubTopicProgressBarLess16">{Number(ppSubTopic.score).toFixed(2) + '%'}</div>}
                                                                                        </> :
                                                                                        <div className="progress-bar ppConfSubTopicProgressBarZero">{ppSubTopic.score + '%'}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                        : null
                                                }
                                                <hr className='w-100'></hr>
                                            </>
                                            : null
                                        }
                                    </>
                                )
                            })
                        }
                    </div>
                </>
            }
        </>
    )
}